import { DeleteFilled, EditOutlined, EyeFilled } from "@ant-design/icons";
import { Button, Col, Pagination, Row, Space, Table } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotFound from "../../../../components/common/notFound";
import ConfirmModal from "../../../../components/modal/confirmModal";
import FailModal from "../../../../components/modal/failModal";
import SuccessModal from "../../../../components/modal/successModal";
import {
  DATA_MASTER_DATA_TYPE,
  INDUSTRY,
  REGION_GROUP,
  SUCCESS_CODE,
  WORK_PERIOD,
} from "../../../../lib/const";
// import useEState from "../../../../lib/hooks/useEState";
import useLineOfWork from "../../../../lib/hooks/useLineOfWork";
import useMasterData from "../../../../lib/hooks/useMasterData";
import { routes } from "../../../../routes";
import {
  deleteCurrentCustomer,
  searchCurrentCustomers,
} from "../../../../services/customerCurrent";
import { SearchCurrentCustomerContext } from "../searchContext";

const Content = ({ roleUser }) => {
  const navigate = useNavigate();
  const {
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    setSearch,
  } = useContext(SearchCurrentCustomerContext);
  const [lineOfWork] = useLineOfWork();
  // const [estate] = useEState();
  const [regionGroup] = useMasterData(DATA_MASTER_DATA_TYPE, REGION_GROUP);
  const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);
  const [industries] = useMasterData("", INDUSTRY);

  let [no, setNo] = useState(0);
  // const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    id: 0,
    show: false,
    type: "",
  });
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

  const fetchCurrentCustomers = useCallback(
    async (searchValues, pageValues) => {
      const res = await searchCurrentCustomers(searchValues, pageValues);
      const { objectValue, pageValue } = res.data;
      if (res?.data?.code === SUCCESS_CODE) {
        let _p =
          parseInt(pageValues.page) === 0
            ? parseInt(pageValues.page)
            : parseInt(pageValues.page) * pageValues.pageSize;
        setNo(_p);
        setDataSource(objectValue);
        // setSearchValues(objectValue);
        setPageValues(pageValue);
      } else {
        setDataSource([]);
        setPageValues((prev) => ({
          ...prev,
          page: 0,
          pageSize: 10,
          total: 0,
          totalPage: 0,
        }));
        if (parseInt(pageValues.page) !== 0) {
          setSearch(true);
        }
      }
    },
    [setDataSource, setSearchValues, setPageValues, setSearch]
  );

  useEffect(() => {
    if (search) {
      fetchCurrentCustomers(searchValues, pageValues);
      setSearch(false);
    }
  }, [fetchCurrentCustomers, search]);

  const columns = [
    {
      align: "center",
      title: "ลำดับ",
      dataIndex: "no",
      render: () => <span>{(no += 1)}</span>,
    },
    {
      title: "สายงาน",
      dataIndex: "lineOfWorkId",
      key: "lineOfWorkId",
      sorter: (a, b) => a.lineOfWorkId - b.lineOfWorkId,
      render: (_, record) => (
        <span>
          {lineOfWork &&
            lineOfWork.map((e) =>
              e.lineOfWork === record.lineOfWorkId ? e.nameTh : ""
            )}
        </span>
      ),
    },
    {
      title: "นิคมอุตสาหกรรม",
      dataIndex: "estateNameTh",
      key: "estateNameTh",
      sorter: (a, b) => a.estateNameTh - b.estateNameTh,
      render: (_, record) => {
        // const arr = record.estateNameTh ? record.estateNameTh.split(",") : null;
        return (
          <>
            {record.estateNameTh}
            {/* {arr?.length > 0
              ? arr?.map((item, index) =>
                  estate.map((e) =>
                    e.estateId === item ? (
                      <div>
                        {e.estateNameTh}
                        {index + 1 !== arr?.length && ", "}
                      </div>
                    ) : (
                      ""
                    )
                  )
                )
              : "-"} */}
          </>
        );
      },
    },
    {
      title: "ชื่อสถานประกอบการ/ชื่อโรงงาน",
      dataIndex: "factoryNameEn",
      key: "factoryNameEn",
      sorter: (a, b) => a.factoryNameEn - b.factoryNameEn,
      render: (_, record) => (
        <>
          <div>{record.factoryNameTh}</div>
          <div style={{ color: "#82858E" }}>{record.factoryNameEn}</div>
        </>
      ),
    },
    {
      title: "กลุ่มลูกค้าตาม ระยะเวลา ",
      dataIndex: "customerGroupByAge",
      key: "customerGroupByAge",
      sorter: (a, b) => a.customerGroupByAge - b.customerGroupByAge,
      render: (_, record) => (
        <span>
          {workPeriod &&
            workPeriod.map((e) => {
              return e.dataId === record.customerGroupByAge
                ? e.dataDetailTh
                : "";
            })}
        </span>
      ),
    },
    {
      title: "กลุ่มลูกค้าตามสัญชาติ",
      dataIndex: "customerGroupByRegion",
      key: "customerGroupByRegion",
      sorter: (a, b) => a.customerGroupByRegion - b.customerGroupByRegion,
      render: (_, record) => {
        const arr = record.customerGroupByRegion
          ? record.customerGroupByRegion.split(",")
          : null;
        return (
          <>
            {arr?.length > 0
              ? arr?.map((item, index) =>
                  regionGroup.map((e) =>
                    e.dataId === item ? (
                      <div>
                        {e.dataDetailTh}
                        {index + 1 !== arr?.length && ", "}
                      </div>
                    ) : (
                      ""
                    )
                  )
                )
              : "-"}
          </>
        );
      },
    },
    {
      title: "ประเภทอุตสาหกรรม",
      dataIndex: "typeOfEstate",
      key: "typeOfEstate",
      sorter: (a, b) => a.typeOfEstate - b.typeOfEstate,
      render: (_, record) => {
        return (
          <span>
            {industries &&
              industries.map((e) =>
                e.industryId === record.typeOfEstate ? e.industryNameTh : ""
              )}
          </span>
        );
      },
    },
    {
      title: "คำสั่ง",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space>
          {!roleUser[0]?.isEdit &&
            !roleUser[0].isDelete &&
            roleUser[0]?.isView && (
              <Button
                className="btn-view"
                shape="circle"
                icon={<EyeFilled style={{ color: "#2e90fa" }} />}
                onClick={() =>
                  navigate(
                    routes.view_customer_current +
                      "/" +
                      record.currentCustomerId
                  )
                }
              />
            )}

          {roleUser[0]?.isEdit && (
            <Button
              className="btn-edit"
              shape="circle"
              icon={
                <EditOutlined
                  style={{
                    color: record.editable === false ? "lightgray" : "#F79009",
                  }}
                />
              }
              disabled={record.editable === false}
              onClick={() =>
                navigate(
                  routes.view_customer_current + "/" + record.currentCustomerId
                )
              }
            />
          )}

          {roleUser[0]?.isDelete && (
            <Button
              className="btn-delete"
              shape="circle"
              icon={
                <DeleteFilled
                  style={{
                    color: record.editable === false ? "lightgray" : "#F04438",
                  }}
                />
              }
              disabled={record.editable === false}
              onClick={() => {
                setConfirmModal({
                  type: "delete",
                  show: true,
                  id: record.currentCustomerId,
                });
              }}
            />
          )}
        </Space>
      ),
    },
  ];

  const handleDelete = async () => {
    const res = await deleteCurrentCustomer(confirmModal.id);
    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setSearch(true);
    } else {
      setFailModal(true);
    }
    setTimeout(() => {
      setFailModal(false);
      setSuccessModal(false);
    }, 2000);
    setConfirmModal({
      show: false,
      id: 0,
      type: "",
    });
  };

  const onSorter = (pagination, filters, sorter) => {
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      sortBy: sorter && sorter.order ? sorter.columnKey : "currentCustomerId",
      sortDirection:
        sorter && sorter.order
          ? sorter.order === "ascend"
            ? "ASC"
            : "DESC"
          : "ASC",
    }));
  };

  const onPageChange = (page, pageSize) => {
    setNo(no + pageSize);
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
  };

  return (
    <div style={{ marginTop: 20 }}>
      <p style={{ margin: "30px 0 10px 0", fontWeight: 500 }}>
        รายการทั้งหมด{" "}
        <span className="pr-purple" style={{ fontWeight: 700 }}>
          {pageValues.total}
        </span>{" "}
        รายการ
      </p>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table
            locale={{ emptyText: <NotFound /> }}
            // loading={loading}
            rowKey={"key"}
            dataSource={dataSource}
            columns={columns}
            scroll={{
              x: 1300,
            }}
            pagination={false}
            onChange={onSorter}
          />
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues.page + 1 || 1}
            total={pageValues.total || 10}
            onChange={onPageChange}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>

      <ConfirmModal
        actionType={"delete"}
        title={"ยืนยันการลบข้อมูล"}
        modalText={"คุณต้องการลบข้อมูล ?"}
        open={confirmModal.type === "delete" ? confirmModal.show : false}
        onOk={() => {
          handleDelete();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </div>
  );
};

export default Content;
